module.exports = __webpack_public_path__ + "img/solution.2ac502d3.png";